export enum ExcelUploadOutcome {
  UPLOAD_SUCCESS = 'upload-success',
  PARTIAL_SUCCESS = 'partial-success',
  UPLOAD_FAILED = 'upload-failed',
}

export enum ExcelUploadModalState {
  OVERWRITE_WARNING = 'overwrite-warning',
  UPLOAD = 'upload',
  UPLOAD_SUCCESS = 'upload-success',
  PARTIAL_SUCCESS = 'partial-success',
  UPLOAD_FAILED = 'upload-failed',
}
